/**
 * Copyright (c) 2017 CRF Box Oy. All Rights Reserved. Company Confidential.
 */
import React from 'react';
import { connect } from 'react-redux';
import DelegationLog from './delegationlog.component';
import { fetchDelegationLog } from '../../actions/delegation.log.actions';
import { fetchStudyPersonnelReportCVS, clearReportCVS } from '../../actions/study.details.actions';

export const mapStateToProps = (state, ownProps) => {
  return {
    study: state.subject.participantStudy,
    studyGid: ownProps.studyGid,
    sponsor: state.sponsor.selectedSponsor,
    assignments: state.delegationLog.assignments,
    error: state.delegationLog.error,
    errorExport: state.delegationLog.errorExport,
    isFetching: state.delegationLog.isFetching || state.subject.isFetchingStudy,
    isFetchingExport: state.delegationLog.isFetching
  };
};

export const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    loadData: (sponsorGid, studyGid) => {
      dispatch(fetchDelegationLog(sponsorGid, studyGid));
    },
    getVisibility(rows) {
      return rows && rows.length > 0 ? 'show' : 'hide';
    }
  };
};

const DelegationLogContainer = connect(mapStateToProps, mapDispatchToProps)(DelegationLog);

export default DelegationLogContainer;
